// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "e124b810c99426ea7e87b2751d7ffa576817071c/static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"21":"2a222798","98":"c3469f9b","215":"28b12c6b","440":"486bdddc","496":"89e6df15","581":"a474c96c","731":"93042797"}[chunkId] + ".chunk.js";
};